import React, { Dispatch, SetStateAction } from 'react'
import { Trans } from 'react-i18next';
import { ByteMenuContentTypes } from '../byte-hook';
import { useNoAuthHooks } from '../../../../../../../Hooks/hooks';
import useMrByteMenu from './menu-hook';
import { BusinessTypes, ICartItem } from '../../../../../../../Interfaces/componentTypes';
import { ICategory, ICompanyResponse } from '../../../../../../../Interfaces/responseTypes';
import { VisitorPageContents } from '../../../../visitorPage';
import useLanguagesHooks from '../../../../../../../Components/Languages/setLanguage-hooks';
import MenuHeader from '../../Components/Headers/MenuHeader/menuHeader';
import CategoryCard from '../../Components/Cards/Category/categoryCard';
import ItemCard from '../../Components/Cards/Item/itemCard';
import CategorySlider from '../../Components/CategorySlider/categorySlider';
import CustomDialog from '../../../../../../../Components/Dialog/customDialog';
import Cart from '../../Components/Cart/cart';
import BusinessClosedNotice from '../../Components/BusinessClosedNotice/businessClosedNotice';
import { isBusinessClosed } from '../../../../../../../Utilits/utilits';
import styles from './menu.module.scss';
import { ITableReserveForm } from '../../../../../../../Interfaces/formValue-interfaces';

export interface IByteMenuProps {
    is_user: boolean;
    data: ICompanyResponse,
    mainCart: [] | ICartItem[],
    currencySymbol: string,
    isReserveForm: ITableReserveForm | null,
    setMainCart: Dispatch<SetStateAction<[] | ICartItem[]>>
    setContentType: Dispatch<SetStateAction<VisitorPageContents>>,
    onOpenMainCartDialog: () => void,
    onOpenReserveDialog: () => void,
};

const MrByteMenu: React.FC<IByteMenuProps> = (props) => {
    const { data, mainCart, is_user, isReserveForm, setContentType, onOpenMainCartDialog, onOpenReserveDialog } = props
    const { menu_list, id, business_profile, services } = data;
    const {
        open,
        itemRefs,
        pageContent,
        categoryRefs,
        welcomeBoxRef,
        itemHeaderRef,
        topSpacerHeight,
        currencySymbol,
        dialogComponent,
        selectedCategory,
        selectedCategoryId,
        onBack,
        onCloseDialog,
        onOpentItemDialog,
        onClickSearchResult,
        handleCategoryClicker,
    } = useMrByteMenu(props);
    const { activeLanguage } = useLanguagesHooks();
    const { mobileScreen } = useNoAuthHooks();
    const businessType = data.type;
    const isClosed = isBusinessClosed(business_profile);

    return (
        <div className={`${styles.page} ${isClosed ? styles.pageClosed : ''}`}>
            <MenuHeader
                title={data.name}
                logo={data.logo}
                menu_list={menu_list}
                business_profile={business_profile}
                onClickLogo={onBack}
                searchHandler={onClickSearchResult}
                companyId={id}
                setContentType={setContentType}
                is_user={is_user}
                services={services}
                onOpenReserveDialog={onOpenReserveDialog}
            />
            <div className={styles.pageContent}>
                {pageContent === ByteMenuContentTypes.ITEMS
                    ?
                    <div className={styles.itemContentHeader} ref={itemHeaderRef}>
                        {isClosed && business_profile && (
                            <BusinessClosedNotice profile={business_profile} variant="page" />
                        )}
                        <CategorySlider
                            data={menu_list!}
                            onSelectCategory={handleCategoryClicker}
                            selectedId={selectedCategoryId}
                        />
                    </div>
                    :
                    <div className={styles.welcomeBox} ref={welcomeBoxRef}>
                        {isClosed && business_profile && (
                            <BusinessClosedNotice profile={business_profile} variant="page" />
                        )}
                        <div className={styles.welcome}>
                            <p className={`${data.name.length > 12 && mobileScreen ? styles.smallTitle : ''}`}>
                                <Trans
                                    i18nKey={businessType === BusinessTypes.SHOP ? "Visitor.Welcome_Shop" : "Visitor.Welcome"}
                                    values={{
                                        title: data.name,
                                        type: data.type
                                    }}
                                    tOptions={{ interpolation: { escapeValue: false } }}
                                    components={{
                                        br: <br />,
                                        big: <span className={styles.bigText} />,
                                        small: <span className={styles.smallText} />
                                    }}
                                />
                            </p>
                        </div>
                    </div>
                }
                <div
                    className={styles.topSpacer}
                    style={{ height: topSpacerHeight }}
                    aria-hidden="true"
                />
                <div className={styles.cardsBox}>
                    {
                        pageContent === ByteMenuContentTypes.CATEGORIES
                            ?
                            menu_list.map((item) => {
                                const localizedTitle =
                                    item.category[`name_${activeLanguage}` as keyof ICategory] || item.category.name_en;
                                return (
                                    <CategoryCard
                                        key={item.category.id}
                                        title={String(localizedTitle)}
                                        image={item.category.upload_image ?? item.category.default_image}
                                        onClick={() => handleCategoryClicker(item)}

                                    />
                                )
                            })
                            :
                            selectedCategory
                            &&
                            menu_list.map((categoryItem, index) => {
                                const localizedTitle =
                                    categoryItem.category[`name_${activeLanguage}` as keyof ICategory] || categoryItem.category.name_en;
                                return (
                                    <div
                                        key={categoryItem.category.id}
                                        ref={(el) => (categoryRefs.current[categoryItem.category.id] = el)}
                                        className={styles.menuItem}
                                    >
                                        <div className={styles.itemCategoryTitle}>
                                            <p>
                                                {localizedTitle}
                                            </p>
                                        </div>
                                        <div className={styles.cardsBox}>
                                            {categoryItem.items.map((menuItem) => (
                                                <ItemCard
                                                    ref={(el) => (itemRefs.current[menuItem.id] = el)}
                                                    key={menuItem.id}
                                                    data={menuItem}
                                                    currencySymbol={currencySymbol}
                                                    onClick={() => onOpentItemDialog(categoryItem, menuItem)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )
                            }
                            )}

                </div>
            </div>
            <CustomDialog
                open={open}
                onClose={onCloseDialog}
                scrollableContainer
                children={dialogComponent}
            />
            {
                (
                    !business_profile
                        ?
                        <Cart
                            mainCart={mainCart}
                            isReserveForm={isReserveForm}
                            onClick={isReserveForm ? onOpenReserveDialog : onOpenMainCartDialog}
                        />
                        :
                        !mobileScreen && <Cart
                            isReserveForm={isReserveForm}
                            mainCart={mainCart}
                            onClick={isReserveForm ? onOpenReserveDialog : onOpenMainCartDialog}
                        />
                )
            }
        </div>
    )
}

export default MrByteMenu
